import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./settingsStyle.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";
import {Switch, FormControlLabel} from '@mui/material';

export default function Settings() {
    const navigate = useNavigate();

    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");
    const [checkedNewsletter, setCheckedNewsletter] = useState(false);
    const [cookiesChecked, setCookiesChecked] = useState(localStorage.getItem("cookieConsent") === "accepted");
    const [newCookiesState, setNewCookiesState] = useState("");

    useEffect(() => {
        document.title = "DJ - EMAN"

        setCheckedNewsletter(localStorage.getItem("newsletter") === "true");
    }, []);

    const handleSettingsSubmit = async (e) => {
        e.preventDefault();

        const settingsData = {
            password: password,
            passwordRepeat: passwordRepeat,
            newsletter: checkedNewsletter
        }

        try {
            const response = await fetch("https://djeman.de:8443/api/v1/settingsupdate?token=" + Cookies.get("token"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(settingsData),
            });

            if (response.ok) {
                toast.success("Deine Accountdaten wurden angepasst");
                localStorage.setItem("cookieConsent", newCookiesState)
                setPassword("");
                setPasswordRepeat("");
                localStorage.setItem("newsletter", checkedNewsletter);
            } else {
                toast.error(await response.text());
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    function switchSide(side) {
        navigate(side);
    }

    const handleCookiesChange = (event) => {
        setCookiesChecked(event.target.checked);
        if (event.target.checked) {
            setNewCookiesState("accepted");
        } else {
            setNewCookiesState("declined");
        }
    }

    return (
        <div className="settingsContainer">
            <ToastContainer
                theme="dark"
            />
            <h1>Einstellungen</h1>
            <img className="backArrow" onClick={() => switchSide("/musicrequesthome")}src="/img/arrowLeft.svg" />
            <div className="settingsMenuContainer">
                <h2>Deine persönlichen Einstellungen</h2>
                <form onSubmit={handleSettingsSubmit}>
                    <input
                        type="text"
                        placeholder="Neues Passwort"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Neues Passwort wiederholen"
                        value={passwordRepeat}
                        onChange={(e) => setPasswordRepeat(e.target.value)}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={checkedNewsletter}
                                onChange={(e) => setCheckedNewsletter(e.target.checked)}
                            />
                        }
                        label="Newsletter"
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={cookiesChecked}
                                onChange={handleCookiesChange}
                            />
                        }
                        label="Cookies"
                    />
                    <button type="submit">Speichern</button>
                </form>
            </div>
        </div>
    )
}
